export const Menus = [
  {
    path: "latency",
    icon: "fa fa-cloud",
    title: "Latency Test",
  },
  {
    path: "regions",
    icon: "fa fa-book",
    title: "AWS Regions",
  },
  {
    path: "geographies",
    icon: "fa fa-book",
    title: "AWS Geographies",
  },
  {
    path: "about",
    icon: "fa fa-book",
    title: "About",
  },
];
